import { Injectable, inject } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { lastValueFrom, map, take } from 'rxjs';
import { UserModel } from '../models/user.model';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  private afs: AngularFirestore = inject(AngularFirestore);
  constructor() {}

  async getUser(userId: string): Promise<UserModel | null> {
    let u: UserModel | null = null;
    try {
      const docRef = this.afs.doc<UserModel>(`users/${userId}`);
      return lastValueFrom(
        docRef.get().pipe(
          take(1),
          map((snapshot) => {
            if (!snapshot.exists) return null;
            u = snapshot.data() as UserModel;
            u.uid = userId;
            return u;
          })
        )
      );
    } catch (error) {
      console.error('getUser: ', error);
    }
    return u;
  }
}
